import './Hero.css';
import service1 from '../../assets/service1.png';

export default function HeroSection() {
  return (
    <section className="hero" id="home">

      {/* Full-bleed background image */}
      <img
        src={service1}
        alt="Cinematic wedding moment"
        className="hero-img"
      />

      {/* Gradient overlay */}
      <div className="hero-overlay" aria-hidden="true" />

      {/* Film grain texture */}
      <div className="hero-grain" aria-hidden="true" />

      {/* Left content */}
      <div className="hero-content">
        <span className="hero-eyebrow">
          <span className="hero-eyebrow-line" />
          
        </span>

        <h1 className="hero-heading">
          Capturing<br />
          <em>Emotions</em>
          Beyond Frames
        </h1>

        <p className="hero-desc">
          Every smile, every glance, every celebration deserves to be remembered beautifully.
          We create timeless photography and cinematic stories for weddings, families,
          newborns, and special events.
        </p>

        <a href="contact" className="hero-btn">
          <span>Connect</span>
        </a>
      </div>

      {/* Scroll hint */}
      <div className="hero-scroll" aria-hidden="true">
        <span className="hero-scroll-dot" />
        Scroll to explore
      </div>
      

      {/* Bottom-right tag */}
      <div className="hero-img-tag" aria-hidden="true">
        <span className="hero-img-tag-label">Est. 2018</span>
        <span className="hero-img-tag-title">Timeless Stories</span>
      </div>

    </section>
  );
}